import { render, staticRenderFns } from "./CreateUserRolesPage.vue?vue&type=template&id=1b7710fe"
import script from "./CreateUserRolesPage.vue?vue&type=script&lang=ts"
export * from "./CreateUserRolesPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports